<div
  id="contractSection"
  [ngClass]="contractSectionExpanded ? 'aiBoxTwo' : 'aiBoxOne'"
  *ngIf="
    ($safeNavigationMigration(cargoPaymentInfo?.signatureRequired) | lowercase) === 'y' &&
    (isValidated() || isValidatedAmount() || isCashOrCheck())
  "
  #contractSection
>
  <span class="pTittle">Contract acceptance</span>
  <div
    class="messageBox"
    *ngIf="(currentErrorCreditCard || isSignatureObject1) && !isSignatureObject2 && !currentCanceledByUser; else elseSignature2"
  >
    <div class="customIcon"></div>
    <span class="spanText"
      ><b> {{ cargoPaymentInfo?.signatureRequirement === 'AWBSecurity' ? 'AWB' : cargoPaymentInfo?.signatureRequirement }} </b> signature
      completed.</span
    >
  </div>
  <ng-template #elseSignature2>
    <div class="messageBox" *ngIf="(currentErrorCreditCard || isSignatureObject2) && !currentCanceledByUser">
      <div class="customIcon"></div>
      <span class="spanText"
        ><b> {{ cargoPaymentInfo?.signatureRequirement === 'AWBSecurity' ? 'AWB' : cargoPaymentInfo?.signatureRequirement }} </b> signature
        completed.</span
      >
    </div>
    <div class="messageSecondBox" *ngIf="currentErrorCreditCard || isSignatureObject2; else elseCancelSignature">
      <div class="customIcon"></div>
      <span class="spanText"><b>Security</b> signature completed. </span>
    </div>
  </ng-template>
  <ng-template #elseCancelSignature>
    <div class="messageBox" *ngIf="currentCanceledByUser; else elseCustomTimeoutError">
      <div class="customErrorIcon"></div>
      <span class="spanText">Signatures canceled. </span>
    </div>
  </ng-template>
  <ng-template #elseCustomTimeoutError>
    <div class="messageBox" *ngIf="isCustomTimeoutError; else elseSignature">
      <div class="customErrorIcon"></div>
      <span class="spanText">An error occurred. Please try again to complete the transaction.</span>
    </div>
  </ng-template>
  <ng-template #elseSignature>
    <div *ngIf="isDescriptionHidden && this.currentContinueClick && !isSignatureObject1 && !currentErrorCreditCard; else elseBlock">
      <span class="sTitle">Signatures in progress...</span>
    </div>
  </ng-template>
  <ng-template #elseBlock>
    <span class="sTitle">Select requirements to capture signature.</span>
    <br />
    <div class="radioGroup" *ngIf="isHidden === ''">
      <input (change)="onContractSelected($event)" type="radio" name="signatureRadio" id="airWaybill" value="1" />
      <label for="airWaybill">Air waybill</label>
      <input (change)="onContractSelected($event)" type="radio" name="signatureRadio" id="security" value="2" />
      <label for="security">Security</label>
      <input (change)="onContractSelected($event)" type="radio" name="signatureRadio" id="airBillSecurity" value="3" />
      <label for="airBillSecurity">Air waybill + Security</label>
      <input (change)="onContractSelected($event)" type="radio" name="signatureRadio" id="delivery" value="4" />
      <label for="delivery">Delivery</label>
      <input (change)="onContractSelected($event)" type="radio" name="signatureRadio" id="notRequired" value="0" />
      <label for="notRequired">Not required</label>
    </div>
    <div class="radioGroup" *ngIf="isHidden === 'AWB'">
      <input
        (change)="onContractSelected($event)"
        type="radio"
        name="signatureRadio"
        id="awbOnlyAirWaybill"
        value="1"
        [disabled]="currentPaymentType === 'Manual Payment' || isNoSignatureNoPaymentScenario"
      />
      <label
        for="awbOnlyAirWaybill"
        [ngClass]="currentPaymentType === 'Manual Payment' || isNoSignatureNoPaymentScenario ? 'customDisabled' : 'customEnabled'"
        >Air waybill</label
      >
      <input
        (change)="onContractSelected($event)"
        type="radio"
        name="signatureRadio"
        id="awbOnlyNotRequired"
        value="0"
        [checked]="currentPaymentType === 'Manual Payment'"
      />
      <label for="awbOnlyNotRequired">Not required</label>
    </div>
    <div class="radioGroup" *ngIf="isHidden === 'AWBSecurity'">
      <input
        (change)="onContractSelected($event)"
        type="radio"
        name="signatureRadio"
        id="awbSecurityAirBillSecurity"
        value="3"
        [disabled]="currentPaymentType === 'Manual Payment' || isNoSignatureNoPaymentScenario"
      />
      <label
        for="awbSecurityAirBillSecurity"
        [ngClass]="currentPaymentType === 'Manual Payment' || isNoSignatureNoPaymentScenario ? 'customDisabled' : 'customEnabled'"
        >Air waybill + Security</label
      >
      <input
        (change)="onContractSelected($event)"
        type="radio"
        name="signatureRadio"
        id="awbSecurityNotRequired"
        value="0"
        [checked]="currentPaymentType === 'Manual Payment'"
      />
      <label for="awbSecurityNotRequired">Not required</label>
    </div>
    <div class="radioGroup" *ngIf="isHidden === 'Delivery'">
      <input
        (change)="onContractSelected($event)"
        type="radio"
        name="signatureRadio"
        id="deliveryOnlyDelivery"
        value="4"
        [disabled]="currentPaymentType === 'Manual Payment' || isNoSignatureNoPaymentScenario"
      />
      <label
        for="deliveryOnlyDelivery"
        [ngClass]="currentPaymentType === 'Manual Payment' || isNoSignatureNoPaymentScenario ? 'customDisabled' : 'customEnabled'"
        >Delivery</label
      >
      <input
        (change)="onContractSelected($event)"
        type="radio"
        name="signatureRadio"
        id="deliveryOnlyNotRequired"
        value="0"
        [checked]="currentPaymentType === 'Manual Payment'"
      />
      <label for="deliveryOnlyNotRequired">Not required</label>
    </div>
  </ng-template>
</div>
